module.exports = __webpack_public_path__ + "static/media/mia-khalifa-win.811c3f04.jpg";